import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'

// Admin pages
import Overview from 'src/pages/Overview.vue'

import Settings from 'src/pages/Settings.vue'
import SignIn from 'src/pages/Signin.vue'

import Customers from 'src/pages/Customers/Customers.vue'
import CustomersList from 'src/pages/Customers/Customers.list.vue'
import CustomersCreate from 'src/pages/Customers/Customers.create.vue'
import CustomersEdit from 'src/pages/Customers/Customers.edit.vue'

import Users from 'src/pages/Users/Users.vue'
import UsersList from 'src/pages/Users/Users.list.vue'
import UsersCreate from 'src/pages/Users/Users.create.vue'
import UsersEdit from 'src/pages/Users/Users.edit.vue'

import Dealers from 'src/pages/Dealers/Dealers.vue'
import DealersList from 'src/pages/Dealers/Dealers.list.vue'
import DealersCreate from 'src/pages/Dealers/Dealers.create.vue'
import DealersEdit from 'src/pages/Dealers/Dealers.edit.vue'

import Reports from 'src/pages/Reports/Reports.vue'
import ReportsList from 'src/pages/Reports/Reports.list.vue'
import ReportsCreate from 'src/pages/Reports/Reports.create.vue'
import ReportsEdit from 'src/pages/Reports/Reports.edit.vue'

import Bonus from 'src/pages/Bonus/Bonus.vue'
import BonusList from 'src/pages/Bonus/Bonus.list.vue'

import AffiliateGroups from 'src/pages/AffiliateGroups/AffiliateGroups.vue'
import AffiliateGroupsList from 'src/pages/AffiliateGroups/AffiliateGroups.list.vue'
import AffiliateGroupsCreate from 'src/pages/AffiliateGroups/AffiliateGroups.create.vue'
import AffiliateGroupsEdit from 'src/pages/AffiliateGroups/AffiliateGroups.edit.vue'



const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview'
  },
  {
    path: '/signin',
    name: 'Sign In',
    component: SignIn
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'settings',
        name: 'Settings',
        component: Settings
      },
      {
        path: 'overview',
        name: 'Overview',
        component: Overview
      },
      {
        path: 'customers',
        component: Customers,
        redirect: '/customers',
        children: [
          {
            path: '',
            name: 'customers.List',
            component: CustomersList,
          },
          {
            path: 'create',
            name: 'customers.Create',
            component: CustomersCreate,
          },
          {
            path: ':id',
            name: 'customers.Edit',
            component: CustomersEdit,
          }
        ]
      },
      {
        path: 'bonus',
        component: Bonus,
        redirect: '/bonus',
        children: [
          {
            path: '',
            name: 'bonus.List',
            component: BonusList,
          }
        ]
      },
      {
        path: 'users',
        component: Users,
        redirect: '/users',
        children: [
          {
            path: '',
            name: 'users.List',
            component: UsersList,
          },
          {
            path: 'create',
            name: 'users.Create',
            component: UsersCreate,
          },
          {
            path: ':id',
            name: 'users.Edit',
            component: UsersEdit,
          }
        ]
      },
      {
        path: 'dealers',
        component: Dealers,
        redirect: '/dealers',
        children: [
          {
            path: '',
            name: 'dealers.List',
            component: DealersList,
          },
          {
            path: 'create',
            name: 'dealers.Create',
            component: DealersCreate,
          },
          {
            path: ':id',
            name: 'dealers.Edit',
            component: DealersEdit,
          }
        ]
      },
      {
        path: 'affiliate-groups',
        component: AffiliateGroups,
        redirect: '/affiliate-groups',
        children: [
          {
            path: '',
            name: 'affiliate-groups.List',
            component: AffiliateGroupsList,
          },
          {
            path: 'create',
            name: 'affiliate-groups.Create',
            component: AffiliateGroupsCreate,
          },
          {
            path: ':id',
            name: 'affiliate-groups.Edit',
            component: AffiliateGroupsEdit,
          }
        ]
      },
      {
        path: 'reports',
        component: Reports,
        redirect: '/reports',
        children: [
          {
            path: '',
            name: 'reports.List',
            component: ReportsList,
          },
          {
            path: 'create',
            name: 'reports.Create',
            component: ReportsCreate,
          },
          {
            path: ':id',
            name: 'reports.Edit',
            component: ReportsEdit,
          }
        ]
      }
    ]
  },
  { path: '*', component: NotFound }
]


export default routes
